import { gql } from '@apollo/client'

export const Query = gql`
  query CustomField($companyId: ID!, $filters: CustomFieldFilters) {
    customFields(companyId: $companyId, filters: $filters, first: 1) {
      nodes {
        id
        name
        resourceType
        fieldType
        enabled
      }
      pageInfo { startCursor endCursor hasNextPage hasPreviousPage }
    }
  }
`
